var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"itemEdit",on:{"click":function($event){return _vm.$emit('edit')}}},[_c('span',{staticClass:"itemEditText"},[_vm._v(" "+_vm._s(_vm.$t("order.btn.edit"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }